/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery {
    LogsRead {
      queryNames
      message
      status
      countMovie
      countWebseries
      companyName
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
